export const ERRORS = 'Errors';

export const AUTOCOMPLETE_OPEN_TEXT = 'Open';
export const AUTOCOMPLETE_CLOSE_TEXT = 'Close';

export const PENDING_TRANSLATIONS_KEY_LIST = [];

export const DEBOUNCE_SEARCH_TIME = 300;

export const LONG_LOAD_API_TIME = 10000; //10 sec
export const DEFAULT_LONG_LOAD_PAGE_MESSAGE =
  "Operation is in progress. Please don't refresh or close the page!";

export const SPECIAL_CHARS = /[ `!@#$%^&*()+\-=\\[\]{};':"\\|,.<>\\/?~]/;

export const REQUIRED_VALIDATION_TEXT = 'This field is required';
export const ALPHANUMERIC_VALIDATION_TEXT =
  'This field supports only alphanumeric and underscore (_) characters';

export const ALPHABET = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export const MEDDRA_DICTIONARY_ROWS_PER_PAGE = 50;

export const MAIN_ENDPOINTS_LIST = [
  '/forms/getformmodel',
  '/getentitydata',
  '/getentitydefinition',
];

export const ENDPOINTS_WITH_CUSTOM_LONG_LOAD_MESSAGE = [
  '/submitmastersetuprecord',
  '/submitworkflowdata',
  '/savedraft',
  '/bulkupload',
  '/batchupdate',
];

//put here values only in lower case
export const ENDPOINTS_TO_SHOW_LONG_LOAD_API_MESSAGE = [
  ...MAIN_ENDPOINTS_LIST,
  ...ENDPOINTS_WITH_CUSTOM_LONG_LOAD_MESSAGE,
  '/forms/save',
  '/forms/unpublish',
  '/forms/delete',
  '/authentication',
  '/getsearchdata',
  '/gethighvolumeData',
  '/getsupportdata',
  '/requestcontrolprint',
];

export const ENTITIES_WITH_VIEW_COLUMN = ['SDC_DOCUMENT', 'V_SS_SHARED_DOCUMENT_PRTL'];

export const ENDPOINTS_FILE_UPLOAD = [
  '/uploadattachment',
  '/createscormpackage',
  '/report/import',
  '/application-migrations/uploadimportfile',
];

export const FILE_SIZE_UPLOAD_ERROR_TRANSLATION_KEY = 'MaxFileSizeExceededWarning';
export const DEFAULT_FILE_SIZE_UPLOAD_MESSAGE =
  'File will not be uploaded. Allowed file size limit is {0} Megabytes';
export const TOAST_DEFAULT_HIDE_DURATION = 5000;

export const UNSAVED_CONFIRM_MESSAGE = 'Are you sure you want to leave with unsaved changes?';

export const ACTOR_TYPES = {
  INTERNAL_ACTOR: 'INTERNAL ACTOR',
  PERSON: 'PERSON',
  CONTACT: 'CONTACT',
};
